const _ = window._

import React from 'react'
import ReactModal from 'react-modal'
import {classNames, keyActivationHandler} from 'js/studios/shared/utils'
import {CheckMarkCircledIcon, CancelCircledIcon} from 'js/studios/shared/svg_icons'
import {trackEventSP} from 'js/studios/shared/tracking'

export const NON_ENGAGEMENT_BUDGET_OPTIONS = _.range(50, 2500, 50)
export const ENGAGEMENT_BUDGET_OPTIONS = _.range(100, 2500, 100).concat(_.range(2500, 10000, 500)).concat(_.range(10000, 25000, 1000))

export const COMMON_GEM_SHAPES = [
  {
    name: "round",
    img: "https://images.custommade.com/ClzWA0ExpHOhbRd7rOC4cHiKbc0=/custommade-attachments/25df7513df3d496_round_brilliant_padded.jpg",
    label: "Round"
  },
  {
    name: "princess",
    img: "https://images.custommade.com/FItakCyhz9Or9sY33t8Ay8uBESA=/custommade-attachments/4d5cb6534f1d50d_princess_padded.jpg",
    label: "Princess"
  },
  {
    name: "oval",
    img: "https://images.custommade.com/J0E7nLRvbl_tqXAwaVtY_O_VQzM=/custommade-attachments/3a82996f7e186fd_oval_padded.jpg",
    label: "Oval"
  },
  {
    name: "emerald",
    img: "https://images.custommade.com/5ojc--3eYgrCY8dXsdaHA2RpbjA=/custommade-attachments/b088ecc25ffb254_emerald_padded.jpg",
    label: "Emerald"
  },
  {
    name: "pear",
    img: "https://images.custommade.com/HGSFSBK6chFRAN2oIKnNgk56QLk=/custommade-attachments/49c02b31509d78f_pear_padded.jpg",
    label: "Pear"
  },
  {
    name: "elongated_cushion",
    img: "https://images.custommade.com/BfVP2Ht_lxJWp02DhE7xQRQx1TU=/custommade-attachments/7834221eed01b7e_cushion_padded.jpg",
    label: "Elongated Cushion"
  },
  {
    name: "cushion",
    img: "https://images.custommade.com/66iaXNWumyYU8jN0fIxQv-06HEM=/custommade-attachments/3018f573023c3d1_cushion_square_padded.jpg",
    label: "Square Cushion"
  },
  {
    name: "marquise",
    img: "https://images.custommade.com/lsWgHrat4WqBNzrgrxCIsUUfVP0=/custommade-attachments/1cb53c9cdc5cd1f_marquise_padded.jpg",
    label: "Marquise"
  },
  {
    name: "heart",
    img: "https://images.custommade.com/hFKRnQjM2sZSxK1VXe0Tu4_zs6w=/custommade-attachments/5857e23838ac1d1_heart_padded.jpg",
    label: "Heart"
  },
  {
    name: "radiant",
    img: "https://images.custommade.com/ruN0jnT7TZpBljKU8eeuT6REFa8=/custommade-attachments/f8a4391f6df2137_radiant_square_padded.jpg",
    label: "Radiant"
  },
  {
    name: "asscher",
    img: "https://images.custommade.com/OV-g5S4AefjrBlmGto_FBSF4Jlw=/custommade-attachments/4e7105196883fd2_asscher_padded.jpg",
    label: "Asscher"
  }

]
export const UNCOMMON_GEM_SHAPES = [
  {
    name: "rose",
    img: "https://images.custommade.com/OYRU7AmwVBluAsxom2paqj6J80Q=/custommade-attachments/bc94c150a50c974_round_rose-cut_padded.jpg",
    label: "Rose"
  },
  {
    name: "kite",
    img: "https://images.custommade.com/8tlNF6aaWJrXjvaZtxP6HOrfPoM=/custommade-attachments/5c718db8b1b3ceb_kite_padded.jpg",
    label: "Kite"
  },
  {
    name: "hexagon",
    img: "https://images.custommade.com/ghXOVzDh2KKg6aa5LBCYYzBAl34=/custommade-attachments/4ab420427e57266_hexagon_padded.jpg",
    label: "Hexagon"
  },
  {
    name: "trillion",
    img: "https://images.custommade.com/AJlhtoMGndzS3iczxmNGmCz8Y9g=/custommade-attachments/e8fec7656b621ac_trilliant_padded.jpg",
    label: "Trillion"
  },
  {
    name: "calf_coffin",
    img: "https://images.custommade.com/1B1j6rc3l_KiE-Ivc1XIM5fLiVk=/custommade-attachments/2ffb84030dc131c_calf-coffin_padded.jpg",
    label: "Calf / Coffin"
  },
  {
    name: "old_mine",
    img: "https://images.custommade.com/DcwUtyfY4-DLtzdVrexcuFSMHlM=/custommade-attachments/9be9b8fe09d962e_old_mine_cut_padded.jpg",
    label: "Old Mine"
  },
  {
    name: "old_euro",
    img: "https://images.custommade.com/-pnbcEILnWEk5yokkrGGPYvKtes=/custommade-attachments/7515970f8c3889b_old_european_cut_padded.jpg",
    label: "Old Euro"
  },
  {
    name: "half_moon",
    img: "https://images.custommade.com/KEdrGNcv6SI5NsfmhzVdddGgvug=/custommade-attachments/37d88fcb854ac0b_half_moon_padded.jpg",
    label: "Half Moon"
  },
  {
    name: "shield",
    img: "https://images.custommade.com/hBah8oYLrLjSGEzJV4eJ7aX0b6o=/custommade-attachments/20c008808d9c3d1_shield_padded.jpg",
    label: "Shield"
  },
  {
    name: "other",
    img: null,
    label: "Other"
  }
]


export function determineBudgets(field, value, budgetMin, budgetMax){
  budgetMin = parseInt(budgetMin), budgetMax = parseInt(budgetMax), value = parseInt(value)
  let newBudgetMin = budgetMin, newBudgetMax = budgetMax
  if (value){
    if (field === "budgetMax"){
      if (budgetMin && value < budgetMin){
        newBudgetMin = value
        newBudgetMax = budgetMin
      } else {
        newBudgetMax = value
      }
    } else if (field === "budgetMin"){
      if (budgetMax && value > budgetMax){
        newBudgetMin = budgetMax
        newBudgetMax = value
      } else {
        newBudgetMin = value
      }
    }
  } else {
    if (field === "budgetMin"){
      newBudgetMin = null
    } else {
      newBudgetMax = null
    }
  }
  return [newBudgetMin, newBudgetMax]
}

export class PreviousLink extends React.Component {
  render(){
    return (
      <a
        className="previous"
        tabIndex="0"
        aria-label="Go back"
        onClick={this.props.onClick}
        onKeyDown={keyActivationHandler(this.props.onClick)}>
        <i className="material-icons">chevron_left</i>
      </a>
    )
  }
}

export class Select extends React.Component {
  render(){
    const selectId = this.props.id || `select-${Math.random()}`
    const selectAttrs = _.extend({}, this.props, { id: selectId })
    delete selectAttrs.label
    delete selectAttrs.insertLabelOption
    const insertLabelOption = this.props.insertLabelOption === undefined ? true : this.props.insertLabelOption

    return (
      <div className={"new-brand-select-wrapper select-wrapper" + (this.props.disabled ? " disabled" : "")}>
        {this.props.label && <label htmlFor={selectId} hidden>{this.props.label}</label>}
        <select {...selectAttrs}>
          {this.props.label && insertLabelOption && <option value="">-- {this.props.label} --</option>}
          {this.props.children}
        </select>
      </div>
    )
  }
}

export class CheckMarkCard extends React.Component {
  wrapperClassNames() {
    return classNames(
      'card',
      {
        'disabled': this.props.disabled,
        'faded': this.props.faded,
        [this.props.className]: this.props.className,
      },
    )
  }

  onClick(ev) {
    ev.preventDefault()
    if (!this.props.disabled) {
      if (this.props.onClick) {
        this.props.onClick({
          preventDefault: () => {},
          target: { checked: this.props.checked },
        })
      } else {
        this.props.toggleChecked(ev)
      }
    }
  }

  render(){
    return (
      <div
        className={this.wrapperClassNames()}
        role="button"
        aria-pressed={this.props.checked ? "true" : "false"}
        tabIndex="0"
        onClick={this.onClick.bind(this)}
        onKeyDown={keyActivationHandler(this.onClick.bind(this))}
        >
        {this.props.imgUrl && <img src={this.props.imgUrl} />}
        {this.props.imgs && <div className="images">
          {this.props.imgs.map(imgUrl => <img key={imgUrl} src={imgUrl} />)}
        </div>
        }
        {this.props.svg || null}
        {this.props.label && <div className="card-label" title={this.props.label}>{this.props.label}</div>}
        {this.props.description && <p className="card-description">{this.props.description}</p>}
        {this.props.children}
        {this.props.checked && (
          <div className="card-checked-wrapper">
            <CheckMarkCircledIcon />
          </div>
        )}
      </div>
    )
  }
}

export class HelpModal extends React.Component {

  componentDidUpdate(prevProps, _prevState){
    if (prevProps.isOpen !== this.props.isOpen){
      let action = 'action_close_help'
    if (this.props.isOpen){
        action = 'action_open_help'
      }
      trackEventSP(action, 'consultation', {
        name: this.props.name
      })
    }
  }

  componentDidMount() {
    ReactModal.setAppElement('body')
  }

  render(){
    return (
      <ReactModal
        key="help-modal"
        isOpen={this.props.isOpen}
        overlayClassName={"help-modal-overlay" + (this.props.isOpen ? " open" : "")}
        className={"help-modal" + (this.props.className ? " " + this.props.className : "")}
        onRequestClose={this.props.onClose}
        closeTimeoutMS={300}
        contentLabel="help-modal"
      >
        <div className="help-modal-content">
          {this.props.children}
          <a className="help-modal-close" aria-label="Close help modal" tabIndex="0" onClick={this.props.onClose} onKeyDown={keyActivationHandler(this.props.onClose)}>
            <CancelCircledIcon />
          </a>
        </div>
      </ReactModal>
    )
  }
}

export class HelpLink extends React.Component {

  render(){
    return (
      <a className="help material-icons" aria-label="Show help" tabIndex="0" onClick={this.props.onClick} onKeyDown={keyActivationHandler(this.props.onClick)}>info_outlined</a>
    )
  }
}


export class Splash extends React.Component {
  render(){
    return (
      <div className={"splash-wrapper" + (this.props.className ? " " + this.props.className : '')}>
        <div className="flow-splash fade-in">
          <div className="main-contents">
            <div className="logo-container">
              <a href="/">
                <img src="https://images.custommade.com/90zzp4uzgC3IcNXn6rORdtyip3k=/custommade-attachments/13d550c8ed01060_intro_logo.png" alt="CustomMade logo" />
              </a>
            </div>
            <div className="frame">
              {this.props.children}
            </div>
          </div>
          <div className="mobile-logo-container">
            <img src="https://images.custommade.com/l5NhIDjTAVvB3ABnr1fMWO6XNwc=/custommade-attachments/cf711a124360d14_glyph_primary.png" />
          </div>
          <div className={"splash-image " + (this.props.splashClassName ? this.props.splashClassName : "")}></div>
        </div>
      </div>
    )
  }
}
